// UTILS
import { ref } from "vue"
import { defineStore } from "pinia"

// HELPERS
import { sleep } from "@/helpers/sleep"

// MACHINE
import { brainActor } from "@/features/brain/machines/brainMachine"

export const useBrainTutoStore = defineStore("brainTutoStore", () => {
  const isTutorial = ref(true) // default true - false for testing
  const isTutoError = ref(false)
  const tutoAnswerIsPlaying = ref(false)
  const currentTutoStep = ref(0)
  const instructionsDone = ref(false)

  /**
   * Restart the tutorial
   */
  function restartTutorial() {
    isTutorial.value = true
    currentTutoStep.value = 0
    brainActor.send({ type: "restart" })
  }

  /**
   * Reveal the answer for the current tutorial step
   */
  async function revealAnswer() {
    tutoAnswerIsPlaying.value = true

    window.b.rawResetTest()
    await new Promise((resolve) => requestAnimationFrame(resolve))
    window.b.playAnswer(currentTutoStep.value)
  }

  /**
   * Submit the current tutorial step
   */
  async function submitTutoStep() {
    window.b.onSubmitTutoStep()
  }

  /**
   * Open the tutorial error modal
   */
  async function openTutoErrorModal() {
    isTutoError.value = true
    await sleep(4000)
    isTutoError.value = false
  }

  return {
    isTutorial,
    isTutoError,
    tutoAnswerIsPlaying,
    currentTutoStep,
    instructionsDone,
    revealAnswer,
    submitTutoStep,
    openTutoErrorModal,
    restartTutorial,
  }
})
